var _componentMultiselect = function($context) {
    if (!$().multiselect) {
        console.warn('Warning - bootstrap-multiselect.js is not loaded.');
        return;
    }
    
    $context = $context instanceof jQuery ? $context : $(document);

    $context.find('.js-multiselect').multiselect();
    
    $context.find('.js-form-control-multiselect').multiselect({
        includeSelectAllOption: true,
        selectAllText: '[Alles ausgewählt]',
        allSelectedText: 'Alles ausgewählt'
    });
};

function init($context) {
    _componentMultiselect($context);
}

export const Forms = {
    init
}